import { render, staticRenderFns } from "./ChatOrderCard.vue?vue&type=template&id=1933ed20&scoped=true&"
import script from "./ChatOrderCard.vue?vue&type=script&lang=js&"
export * from "./ChatOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderCard.vue?vue&type=style&index=0&id=1933ed20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933ed20",
  null
  
)

export default component.exports